/**
 * Safe localStorage wrapper that handles JSON parse errors gracefully.
 * Prevents app crashes when localStorage data becomes corrupted.
 */

export function createSafeJSONStorage(getStorage: () => Storage) {
  return {
    getItem: (name: string): any => {
      try {
        const value = getStorage().getItem(name);
        if (value === null) {
          return null;
        }
        return JSON.parse(value);
      } catch (error) {
        console.warn(`Error parsing localStorage key "${name}":`, error);
        return null;
      }
    },
    setItem: (name: string, value: any): void => {
      try {
        getStorage().setItem(name, JSON.stringify(value));
      } catch (error) {
        console.error(`Error setting localStorage key "${name}":`, error);
      }
    },
    removeItem: (name: string): void => {
      getStorage().removeItem(name);
    },
  };
}
